import { render, staticRenderFns } from "./MarkdownFieldtype.vue?vue&type=template&id=3c882166&"
import script from "./MarkdownFieldtype.vue?vue&type=script&lang=js&"
export * from "./MarkdownFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports